import { cva } from 'class-variance-authority';
import { cn } from '../../lib';

const buttonVariants = cva(
  cn(
    'inline-flex',
    'items-center',
    'justify-center',
    'rounded-md',
    'text-sm',
    'font-medium',
    'ring-offset-background',
    'transition-colors',
    'focus-visible:outline-none',
    'focus-visible:ring-2',
    'focus-visible:ring-ring',
    'focus-visible:ring-offset-2',
    'disabled:pointer-events-none',
    'disabled:opacity-50'
  ),
  {
    variants: {
      variant: {
        default:
          'bg-background text-default-foreground hover:bg-default-hover border border-default-foreground',
        destructive:
          'bg-destructive text-destructive-foreground hover:bg-destructive-hover',
        destructiveSecondary:
          'bg-background text-destructive-ghost-foreground hover:bg-destructive-ghost-hover border border-destructive-ghost-foreground',
        destructiveGhost:
          'bg-destructive-ghost text-destructive-ghost-foreground hover:bg-destructive-ghost-hover',
        primary: 'bg-primary text-primary-foreground hover:bg-primary-hover',
        secondary:
          'bg-secondary text-secondary-foreground hover:bg-default-hover ',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
        dark: 'bg-dark-background text-dark-foreground hover:bg-active hover:text-active-foreground',
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-9 rounded-md px-3',
        lg: 'h-11 rounded-md px-8',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

export { buttonVariants };
